export const DEFAULT_SKIP = 0;
export const DEFAULT_TAKE = 10;